/**
 * Canonical Femcare taxonomies — pulled from Fertile-Track's
 * `/api/i18n/translations/en` (source of truth). Keep these EXACTLY as
 * mobile/FT expects — writes go through the same FT endpoints, so any
 * label drift produces silent mismatches on the shared canonical record.
 *
 * If FT adds a new symptom/mood/flow, update this file only. Never
 * "improve" or invent options here.
 */

// Displayed left→right, top→bottom on both desktop grid and mobile stack.
// The `value` (snake_case) is what FT stores; the `label` is what we show.
export const SYMPTOMS = [
    { value: "cramps",            label: "Cramps" },
    { value: "headache",          label: "Headache" },
    { value: "bloating",          label: "Bloating" },
    { value: "fatigue",           label: "Fatigue" },
    { value: "nausea",            label: "Nausea" },
    { value: "back_pain",         label: "Back Pain" },
    { value: "breast_tenderness", label: "Breast Tenderness" },
    { value: "acne",              label: "Acne" },
    { value: "insomnia",          label: "Insomnia" },
    { value: "dizziness",         label: "Dizziness" },
    { value: "cravings",          label: "Cravings" },
    { value: "mood_swings",       label: "Mood Swings" },
];

export const MOODS = [
    { value: "happy",     label: "Happy",     emoji: "🙂" },
    { value: "calm",      label: "Calm",      emoji: "😌" },
    { value: "energetic", label: "Energetic", emoji: "⚡" },
    { value: "sad",       label: "Sad",       emoji: "😔" },
    { value: "anxious",   label: "Anxious",   emoji: "😰" },
    { value: "irritable", label: "Irritable", emoji: "😠" },
    { value: "tired",     label: "Tired",     emoji: "😴" },
    { value: "emotional", label: "Emotional", emoji: "🥺" },
];

export const FLOW_LEVELS = [
    { value: "spotting", label: "Spotting" },
    { value: "light",    label: "Light" },
    { value: "medium",   label: "Medium" },
    { value: "heavy",    label: "Heavy" },
];

// Cervical mucus (standard Femcare canonical values — not enumerated in FT i18n
// yet but stored as free string per DailyLogRequest).
export const CERVICAL_MUCUS = [
    { value: "dry",       label: "Dry" },
    { value: "sticky",    label: "Sticky" },
    { value: "creamy",    label: "Creamy" },
    { value: "watery",    label: "Watery" },
    { value: "egg_white", label: "Egg White" },
];

export const OPK_RESULTS = [
    { value: "negative", label: "Negative" },
    { value: "positive", label: "Positive" },
];

export const CYCLE_PHASES = [
    { value: "menstrual",  label: "Menstrual Phase",  color: "#D64D8C" },
    { value: "follicular", label: "Follicular Phase", color: "#B49AD9" },
    { value: "fertile",    label: "Fertile Window",   color: "#5FB878" },
    { value: "ovulation",  label: "Ovulation Phase",  color: "#3E9E5C" },
    { value: "luteal",     label: "Luteal Phase",     color: "#F7C1AC" },
];

export const TRACKING_STATUS = [
    { value: "trying_to_conceive", label: "Trying to Conceive" },
    { value: "avoiding_pregnancy", label: "Avoiding Pregnancy" },
    { value: "just_tracking",      label: "Just Tracking" },
    { value: "pregnant",           label: "Pregnant" },
    { value: "postpartum",         label: "Postpartum" },
];

export const MARITAL_STATUS = [
    { value: "single",   label: "Single" },
    { value: "married",  label: "Married" },
    { value: "partner",  label: "In a Relationship" },
    { value: "other",    label: "Other" },
    { value: "prefer_not_to_say", label: "Prefer not to say" },
];

export const CYCLE_REGULARITY = [
    { value: "regular",   label: "Regular" },
    { value: "irregular", label: "Irregular" },
    { value: "unsure",    label: "Unsure" },
];
